import { ArrowDown01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useState, useRef } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { DATE_RANGE, DATE_RANGES } from '@/constants/global';

interface Props {
    onChange: (selectedRange: DATE_RANGE) => void;
}

const StatsFilters = ({ onChange }: Props) => {
    const anchorRef = useRef<HTMLDivElement>(null);
    const [open, setOpen] = useState(false);
    const [selectedRange, setSelectedRange] = useState<DATE_RANGE>(DATE_RANGE.LAST_SEVEN_DAYS);

    const handleMenuItemClick = (
        event: React.MouseEvent<HTMLLIElement, MouseEvent>,
        id: DATE_RANGE,
    ) => {
        setSelectedRange(id);
        onChange(id);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: Event) => {
        if (
        anchorRef.current &&
        anchorRef.current.contains(event.target as HTMLElement)
        ) {
        return;
        }

        setOpen(false);
    };
    
    return (
        <>
            <ButtonGroup
                ref={anchorRef}
                variant="contained"
            >
                <Button onClick={() => {}}>{DATE_RANGES[selectedRange].label}</Button>
                <Button
                    size="small"
                    onClick={handleToggle}
                >
                    <HugeiconsIcon icon={ArrowDown01Icon} />
                </Button>
            </ButtonGroup>
            <Popper
                sx={{ zIndex: 1 }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList id="order-stats-menu" autoFocusItem>
                                    {Object.entries(DATE_RANGES).map(([id, { label }]) => (
                                        <MenuItem
                                            key={id}
                                            selected={id === selectedRange}
                                            onClick={(event) => handleMenuItemClick(event, id)}
                                        >
                                            {label}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}

export default StatsFilters;
